import React from 'react';
import CabinetIcon from 'views/components/icons/Cabinet';
import LightningIcon from 'views/components/icons/Lightning';
import './CapacityTabPanel.scss';

const CapacityTable = ({ metro, capacityConfiguration }) => {
  return (
    <div className="capacity-table">
      <div className="row">
        <span>Data Centers</span>
        <div className="information">{metro.capacity.datacenters} Locations</div>
      </div>
      <div className="row">
        <span>CabE</span>
        <div className="information">
          <CabinetIcon width={14} height={14} color="#2D2D2D" />
          {capacityConfiguration.cabe === 'total' ? metro.capacity.cabETotal : metro.capacity.cabEAvailable} Cabinets
        </div>
      </div>
      {metro.capacity.capacityTotal !== -1 && (
        <div className="row">
          <span>Sellable Capacity</span>
          <div className="information">{metro.capacity.capacityTotal} kVA</div>
        </div>
      )}
      {metro.capacity.capacityAverage !== -1 && (
        <div className="row">
          <span>Avg. Actual kVA per Cabinet</span>
          <div className="information">
            <LightningIcon width={14} height={14} color="#2D2D2D" />
            {metro.capacity.capacityAverage} kVa
          </div>
        </div>
      )}
    </div>
  );
};

export default CapacityTable;
